import React from 'react';
import { FaUser, FaCode, FaBriefcase } from 'react-icons/fa';

const Navbar = () => {
  return (
    <nav className="bg-[#2E3238] shadow-lg rounded-lg p-4 flex justify-around items-center w-1/2 ml-auto mr-0 mb-8">
      {/* Desktop view */}
      <a href="#about" className="hidden md:flex flex-col items-center text-white hover:text-blue-500 transition-colors">
        <FaUser className="text-2xl mb-1 text-blue-500" />
        <span>About</span>
      </a>
      <a href="#rating" className="hidden md:flex flex-col items-center text-white hover:text-blue-500 transition-colors">
        <FaCode className="text-2xl mb-1 text-blue-500" />
        <span>Skills</span>
      </a>
      <a href="#work" className="hidden md:flex flex-col items-center text-white hover:text-blue-500 transition-colors">
        <FaBriefcase className="text-2xl mb-1 text-blue-500" />
        <span>Experience</span>
      </a>
      
      {/* Mobile view */}
      <div className="md:hidden flex flex-row items-center justify-between w-full">
        <a href="#about" className="text-white hover:text-blue-500 transition-colors">
          <FaUser className="text-2xl" />
        </a>
        <a href="#rating" className="text-white hover:text-blue-500 transition-colors">
          <FaCode className="text-2xl mx-4" />
        </a>
        <a href="#work" className="text-white hover:text-blue-500 transition-colors">
          <FaBriefcase className="text-2xl" />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
